namespace GeniuzPOS.Purchase {
    export interface PoInvoiceReceiveAppRow {
        Id?: number;
        SysDocNo?: string;
        PurIvNo?: string;
        ShopId?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        ShipId?: string;
        WhsId?: string;
        ShipDate?: string;
        VatFg?: VatFgstatus;
        TaxInvoiceNo?: string;
        TaxInvoiceDate?: string;
        CashOrTermfg?: CashOrTermfg;
        PayTermCode?: string;
        DueDate?: string;
        TotalAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        NetAmt?: number;
        NetExVat?: number;
        NetTotalInVat?: number;
        SalesVatTypes?: string;
        VatCode?: string;
        VatRate?: number;
        VatAmt?: number;
        ExciseTaxAmt?: number;
        PurInvoiceAmt?: number;
        DepositAmt?: number;
        PaymentType?: paymenttypefg;
        RefType?: string;
        ChequeNo?: string;
        ChequeDate?: string;
        BankId?: string;
        PaymentRefNo?: string;
        CurrencyCode?: string;
        ExchangeRate?: number;
        CurrencyAmt?: number;
        PaymentBeforeDisc?: number;
        PaymentDicsAmt?: number;
        PaymentDicsRemark?: string;
        PaymentAmt?: number;
        WhtAmt?: number;
        PaymentNetAmt?: number;
        ReceiptAmt?: number;
        BalanceAmt?: number;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        UseFg?: number;
        LastDateStatusChange?: string;
        Refuse?: string;
        SendForAppfg?: sendapp;
        CancelFg?: CancelFgstatus;
        RejectFg?: number;
        CheckQty?: number;
        ApproveFg?: number;
        ApproveLv?: number;
        ApproveBy?: string;
        ApproveDate?: string;
        PostFg?: number;
        PostDate?: string;
        CusNetAmt?: number;
        CusVatAmt?: number;
        CusPurInvoiceAmt?: number;
        CusNetAmtDiff?: number;
        CusVatDiff?: number;
        CusCurrencyCode?: string;
        CusExchangeRate?: number;
        CusCurrencyAmt?: number;
        ErPfg?: number;
        POTypeFg?: POTypeFg;
        DtList?: PoInvoiceReceiveDtRow[];
        AppList?: PoApprovalTranRow[];
    }

    export namespace PoInvoiceReceiveAppRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoInvoiceReceiveApp';
        export const lookupKey = 'Purchase.PoInvoiceReceiveApp';

        export function getLookup(): Q.Lookup<PoInvoiceReceiveAppRow> {
            return Q.getLookup<PoInvoiceReceiveAppRow>('Purchase.PoInvoiceReceiveApp');
        }
        export const deletePermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            PurIvNo = "PurIvNo",
            ShopId = "ShopId",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            ShipId = "ShipId",
            WhsId = "WhsId",
            ShipDate = "ShipDate",
            VatFg = "VatFg",
            TaxInvoiceNo = "TaxInvoiceNo",
            TaxInvoiceDate = "TaxInvoiceDate",
            CashOrTermfg = "CashOrTermfg",
            PayTermCode = "PayTermCode",
            DueDate = "DueDate",
            TotalAmt = "TotalAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            NetAmt = "NetAmt",
            NetExVat = "NetExVat",
            NetTotalInVat = "NetTotalInVat",
            SalesVatTypes = "SalesVatTypes",
            VatCode = "VatCode",
            VatRate = "VatRate",
            VatAmt = "VatAmt",
            ExciseTaxAmt = "ExciseTaxAmt",
            PurInvoiceAmt = "PurInvoiceAmt",
            DepositAmt = "DepositAmt",
            PaymentType = "PaymentType",
            RefType = "RefType",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            BankId = "BankId",
            PaymentRefNo = "PaymentRefNo",
            CurrencyCode = "CurrencyCode",
            ExchangeRate = "ExchangeRate",
            CurrencyAmt = "CurrencyAmt",
            PaymentBeforeDisc = "PaymentBeforeDisc",
            PaymentDicsAmt = "PaymentDicsAmt",
            PaymentDicsRemark = "PaymentDicsRemark",
            PaymentAmt = "PaymentAmt",
            WhtAmt = "WhtAmt",
            PaymentNetAmt = "PaymentNetAmt",
            ReceiptAmt = "ReceiptAmt",
            BalanceAmt = "BalanceAmt",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            UseFg = "UseFg",
            LastDateStatusChange = "LastDateStatusChange",
            Refuse = "Refuse",
            SendForAppfg = "SendForAppfg",
            CancelFg = "CancelFg",
            RejectFg = "RejectFg",
            CheckQty = "CheckQty",
            ApproveFg = "ApproveFg",
            ApproveLv = "ApproveLv",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            PostFg = "PostFg",
            PostDate = "PostDate",
            CusNetAmt = "CusNetAmt",
            CusVatAmt = "CusVatAmt",
            CusPurInvoiceAmt = "CusPurInvoiceAmt",
            CusNetAmtDiff = "CusNetAmtDiff",
            CusVatDiff = "CusVatDiff",
            CusCurrencyCode = "CusCurrencyCode",
            CusExchangeRate = "CusExchangeRate",
            CusCurrencyAmt = "CusCurrencyAmt",
            ErPfg = "ErPfg",
            POTypeFg = "POTypeFg",
            DtList = "DtList",
            AppList = "AppList"
        }
    }
}
